import axios from 'axios';
import { apiConfig } from '../config';

// ----------------------------------------------------------------------
const axiosInstance = axios.create({
  baseURL: apiConfig.apiBaserl
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) Promise.reject('Cancel');
    else return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosInstance;
